import { VueModule } from '@Foundation/utilities';
import LanguageSwitcher from './code/Scripts/components/language-switcher.vue';

export default VueModule({
    components: {
        LanguageSwitcher
    }
});